module.exports = __webpack_public_path__ + "public/img/horizontal_menu_logo.8d2c85c5.png";